import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserLicence, UserLicenceAuthResponse } from 'app/shared/models/Users/user';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { ItemRss } from '../../models/itemRss/itemRss';
import { PersonaArray } from '../../models/Label-Persona/label-persona';
import { LabelValeur } from '../../models/LabelValeur/labelValeur';
import { LinkAccount } from '../../models/Link-Account/linkAccount';
import { ListeLigue } from '../../models/List-Ligue/list-ligue';
import { Menu } from '../../models/Menus/menus';
import { ResPersonasGenericAndUser } from '../../models/Persona/persona';
import { ResetPasswordByMail } from '../../models/Reset-Password/resetPasswordByMail';
import { UpdatePassword } from '../../models/Update/updatePassword';
// import { PersonaSelected } from '../models/updatePersona';
import { UpdateUser } from '../../models/Update/updateUser';
import { UserToAdd } from '../../models/Users/usertoadd';
import { ValideUser } from '../../models/Users/valideUser';

@Injectable({ providedIn: 'root' })
export class UserService {
  constructor(private http: HttpClient) { }

  /* ----------------------------------- GET ---------------------------------- */

  getphoto(): Observable<string> {
    const token = localStorage.getItem(environment.tokenKey);
    return this.http.get<string>(`${environment.apiUrl}/User/photo`);
  }

  sendEmailUserForResetPassword(email: string) {
    return this.http.get<any>(`${environment.apiUrl}/User/password/${email}`);
  }

  getMenuUser(): Observable<Menu[]> {
    return this.http.get<Menu[]>(`${environment.apiUrl}/User/menu`);
  }

  getFluxRss(title: string) {
    return this.http.get<ItemRss[]>(`${environment.apiUrl}/User/rss/${title}`);
  }


  getPersona(): Observable<ResPersonasGenericAndUser> {
    return this.http.get<ResPersonasGenericAndUser>(`${environment.apiUrl}/User/persona`);
  }

  allMyActus(addPersona: boolean = false, addFonction: boolean = false): Observable<ItemRss[]> {
    return this.http.get<ItemRss[]>(`${environment.apiUrl}/User/rss?persona=${addPersona}&fonction=${addFonction}`);
  }

  getFluxRssLigues(): Observable<ListeLigue> {
    return this.http.get<ListeLigue>(`${environment.apiUrl}/User/ligues?all=false`);
  }

  getFluxRssMyLigue(code: string, addPersona: boolean = false, addFonction: boolean = false): Observable<ItemRss[]> {
    return this.http.get<ItemRss[]>(`${environment.apiUrl}/User/ligues/code/${code}?persona=${addPersona}&fonction=${addFonction}`);
  }

  getAllRegates() {
    const token = localStorage.getItem(environment.tokenKey);
    return this.http.get(`${environment.apiUrl}/user/regates`);
  }

  getLinkExterne(title: string): Observable<string> {
    return this.http.get<string>(`${environment.apiUrl}/User/link/${title}`);
  }

  getLabelValeur(title: string): Observable<LabelValeur[]> {
    return this.http.get<LabelValeur[]>(`${environment.apiUrl}/User/lv/${title}`);
  }

  /* -------------------------------------------------------------------------- */

  /* ---------------------------------- POST ---------------------------------- */

  registerUser(user: UserToAdd) {
    return this.http.post<UserToAdd>(`${environment.apiUrl}/User`, user);
  }

  resetPasswordByMail(id: number, password: ResetPasswordByMail) {
    return this.http.post<any>(`${environment.apiUrl}/User/${id}/password-reset`, password);
  }

  linkMyAccount(link: LinkAccount) {
    return this.http.post(`${environment.apiUrl}/User/licence`, link);
  }

  getUserLicenceFFV(user: UserLicence) {
    return this.http.post<UserLicenceAuthResponse>(`${environment.apiUrl}/User/ffv`, user);
  }

  createUserByNLicence(user: UserLicenceAuthResponse) {
    return this.http.post(`${environment.apiUrl}/User/licenced`, user);
  }

  /* -------------------------------------------------------------------------- */

  /* ----------------------------------- PUT ---------------------------------- */

  unsubscribe() {
    return this.http.put(`${environment.apiUrl}/User/unsub`, null);
  }

  validationSubscribe(user: ValideUser): Observable<any> {
    return this.http.put<any>(`${environment.apiUrl}/User/validation`, user);
  }

  updatePasswordUser(password: UpdatePassword) {
    return this.http.put<any>(`${environment.apiUrl}/User/password`, password);
  }
  updateUser(userUpdate: UpdateUser) {
    return this.http.put<UpdateUser>(`${environment.apiUrl}/User/`, userUpdate);
  }

  updateMenu(menu: Menu[]) {
    return this.http.put<any>(`${environment.apiUrl}/User/menu`, menu);
  }

  updateUserPhoto(photoUp: any) {
    return this.http.put(`${environment.apiUrl}/User/photo`, { photo: photoUp });
  }

  upDateMyPersona(persona: PersonaArray[]) {
    return this.http.put(`${environment.apiUrl}/User/persona`, persona);
  }

  updateVisibilityMyMenuActu(menuActuUpdate: Menu[]) {
    return this.http.put(`${environment.apiUrl}/User/menu/actu`, menuActuUpdate);

  }
  /* -------------------------------------------------------------------------- */


  /* --------------------------------- DELETE --------------------------------- */

  unLinkMyAccount() {
    return this.http.delete(`${environment.apiUrl}/User/licence`);
  }

  resetOrderMenu(): Observable<Menu[]> {
    return this.http.delete<Menu[]>(`${environment.apiUrl}/User/menu`);
  }

  /* -------------------------------------------------------------------------- */



}
